export enum CertificationStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Incomplete = 'Incomplete',
  Expired = 'Expired'
}

export enum CertificationType {
  ChasAdvanced = 'CHAS Advanced',
  ChasStandard = 'CHAS Standard',
  ChasElite = 'CHAS Elite'
}

export enum VerificationCategory {
  Assured = 4
}

export interface ICertification {
  id: string;
  name: string;
  accreditationTypeId: string;
  status: CertificationStatus;
  validToDateTimeUtc: string;
  subscriptionId: string;
  subscriptionType: string;
  subscriptionExpirationDate: string;
  isSubscriptionDeleted: boolean;
  operationType: string | null;
  displayOrder: number;
  verificationCategory: number | null;
  isExpired?: boolean;
  isCurrentMembershipExpired?: boolean;
}

export interface ICertificationDocument {
  accreditationId: string;
  certificateId?: string;
  documentReferenceId: string;
  accreditationTypeName: string;
  validToDateTimeUtc?: string;
}
